export const branches = [
  { id: 0, value: "First Branch" },
  { id: 1, value: "Second Branch" },
  { id: 2, value: "Third Branch" },
  { id: 3, value: "Fourth Branch" },
];
